import { useState } from "react";
import "./Compliances_Footer.scss";

const Compliances_Footer = ({ handleDoeClick }) => {
  const [isCompleted, setIsCompleted] = useState(false);

  const handleToggle = () => {
    setIsCompleted(!isCompleted);
    handleDoeClick(isCompleted ? "Uncompleted" : "Completed");
  };

  return (
    <div className="Compliances_Footer">
      <button onClick={handleToggle} className="compliances-btn">
        {isCompleted ? "Pending" : "Completed"}
      </button>
    </div>
  );
};

export default Compliances_Footer;
